/** 找商机 公共方法 */

import { getServicePhone } from "@/utils/common";
import { config } from "@/utils/config";

/**
 * 列表搜索提示语
 * @param {Number} type 类型
 * @returns
 */
export const listSearchTipMsg = (type) => {
  switch (type) {
    case 3:
    case 4:
      return "当前条件未搜索到准确结果，以下是为您智能推荐的相关项目";
    case 5:
      return "当前条件未搜索到准确结果，以下是为您自动查询更早发布时间的相关项目";
  }
  return false;
};

/**
 * 列表请求错误，空页面处理情况
 * @param {Object} data 错误信息
 * @returns
 */
export const listErrorEmptyStatus = (data) => {
  const { code, status, msg } = data;
  const errorObj = {
    emptShowType: {
      type: 1,
    }, // 空页面展示状态
    loading: false,
  };

  if (code && msg) {
    errorObj.emptShowType = {
      type: 2,
      msg,
    };
  } else if (code && code === 200050) {
    // 敏感词
    errorObj.emptShowType = {
      type: 1,
    };
  } else if ((status && [500, 503].includes(status)) || code === 503) {
    // 服务端异常情况
    errorObj.emptShowType = {
      type: 2,
      msg: "产品正在维护，请稍后重试",
    };
  } else if (status && status === 429) {
    errorObj.emptShowType = {
      type: 2,
      msg: `抱歉，您在单位时间内的搜索次数已达上限，请联系客服购买会员！咨询电话：${getServicePhone()}`,
    };
  } else if (status && status === config.STATUS_CODE.REQUEST_CANCEL) {
    // 取消本次请求
    errorObj.loading = true;
  } else if (status && status === 504) {
    errorObj.emptShowType = {
      type: 2,
      msg: "请求超时，请稍后重试",
    };
  }

  return errorObj;
};
